import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { WorkflowNote } from '../../models/applications.models';


@Component({
    selector: 'view-notes',
    templateUrl: './view-notes-button.component.html',
    styleUrls: ['./view-notes-button.component.scss'],
    standalone: false
})
export class ViewNotesButtonComponent implements OnInit {

    @Input() fieldName: string;

    private _notes: WorkflowNote[] = [];

    get notes(): WorkflowNote[] {
        return this._notes;
    }

    @Input() set notes(value: WorkflowNote[]) {
        this._notes = value;
    }

    @Output() notesRequested: EventEmitter<string> = new EventEmitter<string>();


    constructor() { }

    ngOnInit() {
    }


    viewNotes(): void {
        this.notesRequested.emit(this.fieldName);
    }
}
